/** 이미지 기능 슬라이스 — 블록 직렬화 + 슬래시(파일 선택 업로드) + 리사이즈 컨트롤. */
import { imageBlockToElement, imageElementToBlock } from "./image.js";
import { attachImageControls } from "./controls.js";

export default {
  name: "image",
  blocks: { image: { toElement: imageBlockToElement, fromElement: imageElementToBlock } },
  controls: (editorEl, ctx) => attachImageControls(editorEl, ctx),
  slash: (ctx) => {
    // 업로더(uploadFile/s3Upload) 미설정 시 이미지 업로드 슬래시 숨김(비디오/오디오와 동일 정책).
    if (!ctx.hasUploader) return [];
    const SM = (ctx.locale && ctx.locale.slashMenu) || {};
    return [
      {
        type: "image",
        label: SM.image || "이미지",
        kw: "image 이미지 그림 사진 picture",
        group: SM.groupMedia || "미디어",
        ico: "🖼",
        sub: "이미지 파일 업로드",
        action: () => ctx.openImagePicker && ctx.openImagePicker(),
      },
    ];
  },
};
